import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import { contactsWithEmailsSelector2, groupsByID2 } from '../selectors'
import LUIS_API_URL from 'utils/LuisApiUrl'

export const getPrediction = (utterance, argObject = {}) => (
  dispatch,
  getState,
) => {
  const state = getState()

  dispatch({
    type: ActionType.LUIS.GET_REQUEST,
    ...argObject,
  })

  return Auth.currentSession()
    .then((session) => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${LUIS_API_URL}utterance=${utterance}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then((res) => res.json().then(data => { if (!res.ok) { return { notOk: true, ...data } } return data }))
        .then((payload) =>
             payload && payload.notOk
            ? dispatch({
                type: ActionType.LUIS.GET_FAILURE,
                payload,
                ...argObject,
              })
            : dispatch({
                type: ActionType.LUIS.GET_SUCCESS,
                payload,
                ...argObject,
                contacts2: contactsWithEmailsSelector2(state),
                groupsByID2: groupsByID2(state),
              }),
        )
        .catch((error) =>
          dispatch({
            type: ActionType.LUIS.GET_FAILURE,
            payload: error,
            ...argObject,
          }),
        )
    })
    .catch((err) => {
      console.log(err)
    })
}
